const getIntro = () => {
    return `
    const AuthGuard = (props) => {
    const { children, roles, componentPermission, moduleID } = props;
    const auth = useAuth();
    const location = useLocation();
    const [requestedLocation, setRequestedLocation] = useState(null);
    `;
}

export default getIntro;
